module.exports = __webpack_public_path__ + "img/W-S35.b7c7aeee.jpg";